import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkMeetTechSection.module.css';

export function DevlinkMeetTechSection({ as: _Component = _Builtin.Section, techGrid, ctaLink = {}, ctaLabel = 'See More' }) {
  return (
    <_Component
      className={_utils.cx(_styles, 'overflow-hidden')}
      grid={{
        type: 'section',
      }}
      tag="section"
    >
      <_Builtin.Block className={_utils.cx(_styles, 'ht-container', 'lg')} tag="div">
        <_Builtin.Block className={_utils.cx(_styles, 'align-center')} tag="div">
          <_Builtin.Heading className={_utils.cx(_styles, 'txt-header')} tag="h3">
            {'Meet our Technicians'}
          </_Builtin.Heading>
        </_Builtin.Block>
        <_Builtin.Block className={_utils.cx(_styles, 'medium-1')} tag="div" />
        <_Builtin.Block className={_utils.cx(_styles, 'ht-meet-tech-section-grid')} tag="div">
          {techGrid}
        </_Builtin.Block>
        <_Builtin.Block className={_utils.cx(_styles, 'medium-1')} tag="div" />
        <_Builtin.Block className={_utils.cx(_styles, 'align-center')} tag="div">
          <_Builtin.Link
            className={_utils.cx(_styles, 'ht-link')}
            button={false}
            block=""
            options={{
              href: '#',
            }}
            {...ctaLink}
          >
            {ctaLabel}
          </_Builtin.Link>
        </_Builtin.Block>
        <_Builtin.Block className={_utils.cx(_styles, 'huge')} tag="div" />
      </_Builtin.Block>
      <_Builtin.Block className={_utils.cx(_styles, 'ht-bg-fill-container')} tag="div">
        <_Builtin.Image
          className={_utils.cx(_styles, 'ht-meet-tech-section-blob')}
          loading="lazy"
          width="auto"
          height="auto"
          alt=""
          src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/6604b7b8a05937fb1181845c_meet-tech-blob.svg"
        />
      </_Builtin.Block>
    </_Component>
  );
}
